import React from 'react';
import EvidenceCard from './EvidenceCard';

const MAX_VISIBLE = 1;

/**
 * Additional Evidence 카드
 *
 * States:
 *   - evidences = []      → text: "No any evidence added. Upload documents to strengthen your profile."
 *   - evidences = ['Portfolio']  → chip (active)
 *   - evidences = ['Portfolio', 'Resume', 'Certificate']  → chip + "+2 more" badge
 *
 * @param {string[]} evidences - e.g. ['Portfolio', 'Resume', 'Certificate']
 */
function AdditionalEvidenceCard({
  evidences = [],
  onManage,
  onAddEvidence,
  evidenceItems,
  sessionId,
  initialScore,
  onEvidenceSave,
  className,
}) {
  const chips = evidences.length > 0
    ? evidences.slice(0, MAX_VISIBLE).map((label) => ({ label }))
    : undefined;

  const moreCount = evidences.length > MAX_VISIBLE
    ? evidences.length - MAX_VISIBLE
    : 0;

  return (
    <EvidenceCard
      color='white'
      title='Additional Evidence'
      chips={chips}
      moreCount={moreCount}
      statusText='No any evidence added. Upload documents to strengthen your profile.'
      secondaryLabel='Manage'
      primaryLabel='Add evidence'
      onSecondaryClick={onManage}
      onPrimaryClick={onAddEvidence}
      evidenceItems={evidenceItems}
      sessionId={sessionId}
      initialScore={initialScore}
      onEvidenceSave={onEvidenceSave}
      className={className}
    />
  );
}

export default AdditionalEvidenceCard;
